import { Link as GatsbyLink } from "gatsby";
import StyleGuideLink from "../styleguide/link";

const InternalLink = StyleGuideLink.withComponent(GatsbyLink);

export default InternalLink;
